import * as React from 'react';
import { useField } from 'formik';
import { InputWrapperWidget } from './inputs';
import { Options, SingleValue } from 'react-select';
import { SelectOptionType, SelectWidget } from '../select/SelectWidget';

type SelectValue = SingleValue<SelectOptionType>;

export interface FormikSelectWidgetProps {
  label?: string;
  name: string;
  error?: string;
  className?: any;
  options: Options<SelectOptionType>;
  defaultValue?: SelectValue;
  disabled?: boolean;
  placeholder?: string;
}

export const FormikSelectWidget: React.FC<FormikSelectWidgetProps> = (props) => {
  const [field, meta, helpers] = useField(props.name);
  const error = meta.touched && (props.error || meta.error);

  return (
    <InputWrapperWidget className={props.className} label={props.label} error={error}>
      <SelectWidget
        {...props}
        isDisabled={props.disabled}
        value={props.options.find((o) => o.value === field.value)}
        onChange={(option: any) => {
          helpers.setValue(option.value);
        }}
        isSearchable={false}
      />
    </InputWrapperWidget>
  );
};
